import React from "react";
import { graphql } from "gatsby";
import Layout from "../components/Layout";
import Seo from "../components/seo";
import { Container, Row, Col } from "react-bootstrap";

// import SampleForm from '../components/Form'
// import { LazyLoadImage } from 'react-lazy-load-image-component'
import "react-lazy-load-image-component/src/effects/blur.css";

class DataEncryptionPage extends React.Component {
  render() {
    const siteTitle = this.props.data.site.siteMetadata.title;
    const siteDescription = this.props.data.site.siteMetadata.description;

    return (
      <Layout title={siteTitle}>
        <Seo title={siteTitle} description={siteDescription} />
        <div id="data-encryption" className="main-heading">
          <Container>
            <Row>
              <Col lg={12} className="m-auto">
                <div className=" text-left py-5 mt-5">
                  <h4 className="hero-title">
                    Encrypt Your Data
                  </h4>
                  <div className="mt-5">
                    <p className="hero-subtitle">
                      Transfer data with confidence. Encrypt it before you send it. 
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <section>
          <Container>
            <Row>
              <Col xs={12} lg={4}>
                <img className="data-encrypt-img" alt="data-encrypt" src="/images/data-encryption-img.png" />
              </Col>
              <Col xs={12} lg={8} className="paragraph-size-20 pt-3">
                <p>
                  Concerned about transferring data over email? Files too large
                  to send over a secured FTP? Need to FedEx a device full of
                  data? Perin says yes to these questions routinely and when we
                  can, encrypts the data using Enigma by BlackSquare
                  Technologies, a trusted source for encrypting data following
                  recommended guidelines for privacy and compliance.
                </p>
                <br />
                <p>
                  Perin has partnered with BlackSquare to provide the Enigma
                  encryption suite of products and services. Most often the data
                  you’re handling is either important or valuable or both, and
                  if placed in the wrong hands, is subject to compromise and
                  dangerous outcomes. Why put you and your stakeholders in this
                  position when you can take control of the data through
                  encryption?
                </p>
              </Col>
            </Row>
          </Container>
        </section>
        <section id="data-encryption-footer-img">
          <Container>
            <Row>
              <Col className="m-auto pt-5">
                <div className=" text-center pt-5 pb-3 footer-pad">
                  <p className="sole-source-sub-head">
                    Start A Conversation. <br /> Schedule Today.
                  </p>
                </div>
                <div className="text-center pt-3">
                  <a href="https://calendly.com/perindiscovery/30minutes" className="btn-primary perin-data-encryption-contact-btn">
                    CONTACT US
                  </a>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </Layout>
    );
  }
}

export default DataEncryptionPage;

export const DataEncryptionPageQuery = graphql`
  query DataEncryptionPageQuery {
    site {
      siteMetadata {
        title
        author
        description
      }
    }
  }
`;
